import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import {GRAY_SEMIDARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface NoFlowchartViewerProps {
  message: string;
}

export default function NoFlowchartViewer({message}: NoFlowchartViewerProps): JSX.Element {
  return (
    <div className={css(styles.wrapper)} {...getTestProps({component: 'NoFlowchartViewer', element: 'root'})}>
      <div className={css(styles.contents)}>
        <BenchlingIcon className={css(styles.workflowIcon)} icon="workflow" />
        <span className={css(styles.text)}>{message}</span>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  workflowIcon: {
    color: GRAY_SEMIDARK,
    height: 24,
    width: 24,
    marginBottom: 8,
  },
  contents: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  text: {
    color: GRAY_SEMIDARK,
    width: '50%',
    textAlign: 'center',
  },
  wrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
